import React from 'react';
import i18n from '../../../../i18n';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import { Text, TextTypography } from 'components/Text/Text';

import { RoutePath } from 'RoutePath';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
    },
    message: {
        flex: 3,
        textAlign: 'left',
    },
    action: {
        flex: 1,
        textAlign: 'right',
    },
}));

export const AlreadyRegistered = () => {
    const { t } = i18n.useTranslation();
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <div className={classes.message}>
                <Text typography={TextTypography.PARA}>{t('auth:signup.alreadyRegisteredMessage')}</Text>
            </div>
            <div className={classes.action}>
                <Link to={RoutePath.LOGIN}>
                    <Text typography={TextTypography.PARA_ACCENT}>{t('auth:signup.login')}</Text>
                </Link>
            </div>
        </div>
    );
};
